<template>
  <div>
    <el-input v-model="fabricContent" readonly :size="size" :disabled="disabled">
      <el-button
        v-if="!disabled"
        slot="append"
        @click="chooseVisible = true"
        :size="size"
      >
        {{ $l('INDEX.btn_editFabricContent') || '编辑成分' }}
      </el-button>
    </el-input>

    <Choose :visible.sync="chooseVisible" @confirm="chooseConfirm" />
  </div>
</template>
<script>
import Choose from './components/choose'
import lodash from 'lodash'
export default {
  components: { Choose },
  props: {
    fabricContent: { type: String, default: '' },
    fabricContentEn: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    size: { type: String, default: '' },
  },
  data() {
    return { chooseVisible: false }
  },
  methods: {
    chooseConfirm(data) {
       const sortedData = lodash.orderBy(data, ['componentPositionCn', 'content'], ['desc', 'asc'])
      const fabricContent = sortedData
        .map((item) => {
          const { content, componentPositionCn, optionName } = item
          return [componentPositionCn, `${content}%`, optionName]
            .filter(Boolean)
            .join(' ')
        })
        .join('; ')
      const fabricContentEn = sortedData
        .map((item) => {
          const { content, componentPositionEn, optionNameEn } = item
          return [componentPositionEn, `${content}%`, optionNameEn]
            .filter(Boolean)
            .join(' ')
        })
        .join('; ')

      this.$emit('change', { fabricContent, fabricContentEn })
      this.$emit('update:fabricContent', fabricContent)
      this.$emit('update:fabricContentEn', fabricContentEn)
    },
  },
}
</script>
